import React from "react";
import {CoursePage } from "../components/Course";

const Graphic = () => (
  <CoursePage pageTitle={'Graphic'} />
);

export default Graphic;
